import {NavigationSearch} from '../../../application/autocomplete/navigationSearch';
import {Popup} from '../../../application/popup';
import {Api} from '../../../application/api/api';
import {ReadyProvider} from '../../../application/providers/readyProvider';
import {LazyDmcaBadge} from '../../../application/lazyLoad/lazyDmcaBadge';
import {LazyGoogleAdsense} from '../../../application/lazyLoad/lazyGoogleAdsense';
import {LazyCookieMessage} from '../../../application/lazyLoad/lazyCookieMessage';
import {LazyImages} from '../../../application/lazyLoad/lazyImages';
import {GoogleAnalytics} from '../../../application/analytics/googleAnalytics';
import {ConfigProvider} from "../../../application/config/configProvider";

ReadyProvider.executeOnReady(() => {

    Array.from(document.querySelectorAll('[data-click="shop"]')).forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            let alias = event.currentTarget.dataset['shopAlias'];
            let urlPattern = ConfigProvider.get('shop_click_route_pattern');
            let clickUrl = urlPattern.replace('shop_alias', alias);

            window.open(clickUrl).focus();
        });
    });

    Array.from(document.querySelectorAll('[data-read-more="toggle"]')).forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            event.currentTarget.closest('[data-block="read-more"]').classList.toggle('visible');
        });
    });

    Array.from(document.querySelectorAll('[data-action="post-submit"]')).forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            Api.postSubmitWithReload(event.currentTarget.getAttribute('data-endpoint'));
        });
    });

    Array.from(document.querySelectorAll('[data-submenu="toggle"]')).forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            let element = event.currentTarget,
                submenu = element.closest('[data-block="submenu"]').querySelector('[data-submenu="menu"]');

            if (submenu.classList.contains('d-none')) {
                element.classList.add('opened-submenu');
                submenu.classList.remove('d-none');
            } else {
                element.classList.remove('opened-submenu');
                submenu.classList.add('d-none');
            }
        });
    });

    Array.from(document.querySelectorAll('[data-navigation="toggle"]')).forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            let related = event.currentTarget.getAttribute('data-related'),
                relatedElement = document.querySelector(`[data-navigation="${related}"]`);

            if (!relatedElement) {
                return;
            }

            if (relatedElement.classList.contains('open')) {
                event.currentTarget.classList.remove('open');
                relatedElement.classList.remove('open');

                if (related !== 'content') {
                    document.body.classList.remove('overflow_hidden');
                }
            } else {
                Array.from(document.querySelectorAll('[data-navigation][data-state="toggle"]')).forEach((block) => {
                    block.classList.remove('open');
                });

                event.currentTarget.classList.add('open');
                relatedElement.classList.add('open');

                if (related !== 'content') {
                    document.body.classList.add('overflow_hidden');
                }
            }
        });
    });

    Array.from(document.querySelectorAll('[data-dropdown="toggle"]')).forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            let parent = event.currentTarget.closest('[data-content="dropdown"]');
            parent.querySelector('[data-dropdown="content"]').classList.toggle('open');

            event.currentTarget.classList.toggle('-active');
        });
    });

    let navigationSearchElement = document.querySelector('[data-navigation="search"]'),
        activeNavigationElement = document.querySelector(`.nav-item:not(.dropdown) a[href$="${location.pathname}"]`);

    if (activeNavigationElement) {
        activeNavigationElement.parentNode.classList.add('nav-item-active');
    }

    if (navigationSearchElement) {
        new NavigationSearch(navigationSearchElement);
    }

    new GoogleAnalytics();

    Popup.initToggle();
    Popup.initPopups();

    LazyImages.load();
    LazyCookieMessage.load();

    ReadyProvider.executeWithLazy(() => {
        LazyDmcaBadge.load();
        LazyGoogleAdsense.load();
    });
});
